import { useEffect } from "react";
import AssignmentMarks from "../../components/AdminPortal/AssignmentMark/AssignmentMarks";
import Header from "../../components/AdminPortal/Header/Header";
export default function AssignmentMark() {
  useEffect(() => {
    document.title = "Assignment Marks- LWS Learning Portal";
  }, []);
  return (
    <>
      <Header />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <AssignmentMarks />
        </div>
      </section>
    </>
  );
}
